import { render, staticRenderFns } from "./BoardSave.vue?vue&type=template&id=a277bda2&scoped=true"
import script from "./BoardSave.vue?vue&type=script&lang=js"
export * from "./BoardSave.vue?vue&type=script&lang=js"
import style0 from "./BoardSave.vue?vue&type=style&index=0&id=a277bda2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a277bda2",
  null
  
)

export default component.exports